import React from 'react';

type StatusVariant = 'submitted' | 'approved' | 'released' | 'pending' | 'rejected' | 'sick' | 'casual' | 'holiday';

interface StatusBadgeProps {
  status: string;
  variant?: StatusVariant;
}

function inferVariant(status: string): StatusVariant {
  const s = status.toLowerCase();
  if (s === 'submitted') return 'submitted';
  if (s === 'approved') return 'approved';
  if (s === 'released') return 'released';
  if (s === 'pending') return 'pending';
  if (s === 'rejected') return 'rejected';
  if (s.includes('sick')) return 'sick';
  if (s.includes('casual')) return 'casual';
  if (s.includes('holiday') || s.includes('public')) return 'holiday';
  return 'pending';
}

const variantClasses: Record<StatusVariant, string> = {
  submitted: 'bg-warning-bg text-warning border border-warning/20',
  approved: 'bg-success-bg text-success border border-success/20',
  released: 'bg-info-bg text-info border border-info/20',
  pending: 'bg-warning-bg text-warning border border-warning/20',
  rejected: 'bg-danger-bg text-danger border border-danger/20',
  sick: 'bg-danger-bg text-danger border border-danger/20',
  casual: 'bg-secondary text-secondary-foreground border border-primary/20',
  holiday: 'bg-accent/10 text-accent border border-accent/20',
};

export default function StatusBadge({ status, variant }: StatusBadgeProps) {
  const v = variant ?? inferVariant(status);
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-600 whitespace-nowrap tabular-nums ${variantClasses[v]}`}
    >
      {status}
    </span>
  );
}